import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { form, minLength, required } from '@angular/forms/signals';
import { MatInputModule } from '@angular/material/input';
import { CodeVerificationDto } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '../../abstract';
import { AuraInputCodeVerificationComponent } from '../../inputs';

@Component({
  selector: 'aura-sms-code-form',
  templateUrl: './sms-code-form.component.html',
  imports: [AuraInputCodeVerificationComponent, MatInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraSmsCodeFormComponent extends AbstractSignalFormComponent<CodeVerificationDto> {
  override model: WritableSignal<CodeVerificationDto> = signal<CodeVerificationDto>({ code: '' });

  override formTree = form(this.model, (b) => {
    required(b.code, { when: () => this.isRequired('code') });
    minLength(b.code, 8);
  });

  onCodeChange(newCode: string): void {
    this.model.update((prev) => ({ ...prev, code: newCode.trim() }));
  }
}
